const mEditionBillingAcademySalesDropDownFilters = {
  mEditionBillingAcademySalesDropDownFilters: {
    buttonPrimary: 'FILTRAR',

    buttonSecondary: {
      restartText: 'ACTUALIZAR'
    },

    input: {
      academiaUrl: {
        label: 'Url de la academia',
        placeholder: 'Escribe aquí la url de la academia'
      },

      descuento: {
        label: 'Código de Descuento',
        placeholder: 'Escribe aquí un código'
      },

      divisa: {
        label: 'Monedas'
      },

      email: {
        label: 'Email Alumno',
        placeholder: 'alumno@email.com'
      },

      estado: {
        label: 'Estados de Venta'
      },

      fechaDesde: {
        label: 'Fecha Desde',
        placeholder: 'Desde - DD MM, AAAA'
      },

      fechaHasta: {
        label: 'Fecha Hasta',
        placeholder: 'Hasta - DD MM, AAAA'
      },

      medioPago: {
        label: 'Medios de Pago'
      },

      tiposDeVenta: {
        label: 'Tipos de Venta'
      },

      pais: {
        label: 'País',
        firstOption: 'Todos los países'
      },

      type_product: {
        label: 'Tipos de Producto',
        first: 'Todos los productos',
        second: 'Productos Comunes',
        third: 'Productos Vidroop'
      },

      productos: {
        label: 'Productos'
      }
    }
  }
}

export default mEditionBillingAcademySalesDropDownFilters
